import request from '@/utils/request'

export function pager(data) {
  return request({
    url: '/api/workAttendanceRest/listAll',
    method: 'post',
    data,
  })
}

export function doAdd(data) {
  return request({
    url: '/api/workAttendanceRest/',
    method: 'post',
    data,
  })
}

export function doLeave(data) {
  return request({
    url: '/api/workAttendanceRest/insertLeave',
    method: 'post',
    data,
  })
}

export function doEdit(data) {
  return request({
    url: '/api/workAttendanceRest/',
    method: 'put',
    data,
  })
}

export function doDelete(data, type) {
  return request({
    url: '/api/workAttendanceRest/' + data + '/' + type,
    method: 'delete',
  })
}

export function lastWorkDay() {
  return request({
    url: '/api/workAttendanceRest/lastWorkDay',
    method: 'post',
  })
}
